/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { services } from '@broadleaf/admin-components';

import ColorPaletteField from './ColorPaletteField';
import AuroraColorPickerField from './AuroraColorPickerField';
import PasswordField from './PasswordField';

const { ComponentRegistrar } = services;

ComponentRegistrar.registerFieldComponent('COLOR_PALETTE', ColorPaletteField);
ComponentRegistrar.registerFieldComponent(
  'AR_COLOR_PICKER',
  AuroraColorPickerField
);
ComponentRegistrar.registerFieldComponent('PASSWORD', PasswordField);
